module.exports = __webpack_public_path__ + "img/diamond-half.47f2fcc5.svg";